<template>
    <div class="data_population ps-02">
        <!-- <h4>디에이치퍼스티어아이파크 매매목록</h4> -->

        <div class="search_area2">
            <select v-model="selectedDong" style="width:24%">
                <option v-bind:value="value" v-for="value in selectionList">{{ value }}</option>
            </select>
            <!-- <select>
                <option>디에이치퍼스티어아이파크</option>
                <option>디에이치퍼스티어아이파크</option>
                <option>디에이치퍼스티어아이파크</option>
                <option>디에이치퍼스티어아이파크</option>
                <option>디에이치퍼스티어아이파크</option>
                <option>디에이치퍼스티어아이파크</option>
            </select> -->
            <select v-model="selectedDate">
                <option v-bind:value="key" v-for="(key) in selectMap[selectedDong]">{{ key }}</option>
            </select>
        </div>

        <div class="apt_info" v-if="!!selectedDate">
            <ul>
                <li>
                    <p class="tit">전용면적</p> 
                    <p class="txt" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ areaList }}</p>
                </li>

                <template v-for="(data, idx) in dataList" v-if="idx == 0">
                    <!-- <li><p class="tit">법 정 동</p> <p class="txt">{{ data.val8 }}</p></li> -->
                    <li><p class="tit">주소</p> <p class="txt">{{ data.val8 }} {{ data.val9 }}</p></li>
                    <li><p class="tit">건축년도</p> <p class="txt">{{ data.val7 }}</p></li>
                </template>
            </ul>
        </div>
        
        <div class="lifemap_list ps-02 scroll10" ref="aprListScroll">
            <ul class="list">
                <!-- @click.prevent="selectAptFacIdx(idx, fac)" -->
                <li v-for="(fac, idx) in dataList" :key="idx" @click.prevent="selectAptFacIdx(idx, fac)" style="cursor:pointer;">
                    <!-- <div class="tit"><span class="ct_01">{{ fac.val5 }}</span>[{{ fac.val2 }}년 {{ fac.val3 }}월{{ fac.val4 }}일] {{ fac.val13 }} {{ fac.val10 }}층</div> -->
                    <div class="tit"><span class="date">{{ fac.val2 }}년 {{ fac.val3 }}월{{ fac.val4 }}일</span> 25층 - {{ fac.val1 }}만원</div>
                    <div class="lifemap_tbl mt10" v-show="idx == selectedFacIdx">
                        <table>
                            <colgroup>
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>거래일</th>
                                    <td>{{ fac.val2 }}년 {{ fac.val3 }}월 {{ fac.val4 }}일</td>
                                    <th>층</th>
                                    <td>{{ fac.val10 }}</td>
                                </tr>
                                <tr>
                                    <th>거래금액</th>
                                    <td>{{ fac.val1 }} 만원</td>
                                    <th>거래일자</th>
                                    <td>{{ fac.val2 }}.{{ fac.val3 }}.{{ fac.val4 }}</td>
                                </tr>
                                <tr>
                                    <th>전용면적</th>
                                    <td>{{ fac.val6 }}㎡</td>
                                    <th>건축년도</th>
                                    <td>{{ fac.val7 }}</td>
                                </tr>
                                <tr>
                                    <th>해체여부</th>
                                    <td>{{ fac.val11 }}</td>
                                    <th>해체사유<br>발생일</th>
                                    <td>{{ fac.val12 }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { $_WC } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api";
import gripUtil from "@/libs/grip.util";

export default {
    data() {
        return {
            selectedFacIdx: -1,
            selectedDong: '도곡동',
        }
    },
    watch: {
        selectedDate: {
            immediate: false,
            handler(newVal, oldVal) {
                // 스크롤 최상단 이동
                this.$refs.aprListScroll.scrollTo(0,0);
                // 월 선택 시 목록 선택 초기화
                this.selectedFacIdx = -1;
            }
        },
        selectedDong: {
            immediate: false,
            handler(newVal, oldVal) {
                // this.$store.dispatch('SET_SELECTED_DATE', this.selectMap[newVal][0]);
                this.$eventBus.$emit("Change::Dong", newVal);
            }
        },
    },
    components: {
    },
    computed: {
        ...mapGetters({
            selectedLfcnvncTab: 'getSelectedLfcnvncTab',
            selectedAtTab: 'getSelectedAtTab',
            selectMap: 'getSelectMap',
            aptMap: 'getAptMap',
            apartMap: 'getApartMap',
        }),
        selectedDate: {
            get() { return this.$store.getters.getSelectedDate; },
            set(value) { this.$store.dispatch('SET_SELECTED_DATE', value); }
        },
        dataList() {
            let list = [];
            if(!!this.apartMap && !!this.selectedDate && !!this.selectedDong) {
                if(!!this.apartMap[this.selectedDong]) {
                    list = this.apartMap[this.selectedDong][this.selectedDate];
                    if(!!list) {
                        list = list.sort((pre, cur) => {
                            return Number(cur.basdtVal) - Number(pre.basdtVal);
                        });
                    }
                }
            }
            return list;
        },
        selectionList() {
            let list = [];
            for(let addong in this.apartMap) {
                list.push(addong);
            }
            return list;
        },
        areaList() {
            let list = [];
            let str = '';
            if(!!this.dataList) {
                let dataList = this.dataList;
                dataList.forEach((d, idx) => {
                    let val = Number(d.val6).toFixed(1);
                    if(list.indexOf(val) == -1) {
                        list.push(val);
                    }
                });
                list.forEach((data, index) => {
                    if(index != (list.length -1)) {
                        str += data + ', ';
                    } else {
                        str += data;
                    }
                });
            }
            return str;
        },
    },
    created() {
        this.$eventBus.$on("Change::Dong", (dong) => {
            this.selectedDong = dong;
        });
    },
    methods: {
        selectAptFacIdx(idx, fac) {
            if(this.selectedFacIdx == idx) {
                this.selectedFacIdx = -1;
            } else {
                this.selectedFacIdx = idx;
                // 마커 표출은 x
                // this.aptfacDetail(fac);
            }
        },
        aptfacDetail(fac) {
        	if(typeof fac !== 'undefined') {
        	    if(fac.lgtdVal && fac.lttdVal) {
                    var vm = this;
                    var marker = fac.marker;
                    var w = window.innerWidth;
                    var DIDwidth = (1920 * 3);
                    marker.eventY = marker.y;
                    marker.eventX = marker.x;

                    this.$store.dispatch("SET_SELECTED_MARKER", marker);
                    this.$eventBus.$emit('Set::Apt::Facility::Info', fac);
                }
        	}
        },
        setAreaStr(areaList) {
            let str = '';
            if(!!areaList) {
                str = '-';
                areaList.forEach((area, index) => {
                    if(index < (areaList.length - 1)) {
                        str += this.setAreaLength(area) + ', ';
                    } else {
                        str += this.setAreaLength(area);
                    }

                });
            }
            return str;
        },
        setAreaLength(area) {
            let returnVal = '';
            if(!!area) {
                let strList = area.split('.');
                if(strList.length > 1) {
                    if(strList[1].length > 2) {
                        strList[1] = strList[1].substring(0, 2);
                    }
                    returnVal = strList[0] + '.' + strList[1];
                }
            }
            return returnVal;
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
<style>
.lifeconv_info .search_area2 select {
    width: 190px;
}
@media (min-width: 0) and (max-width: 768px) {
    .lifeconv_info .search_area2 select {
        width: 160px;
    }
}
@media (min-width: 2737px) and (max-width: 7680px) {
    .lifeconv_info .search_area2 select {
        width: 500px;
    }
}


.tooltip {
  position: relative;
  display: block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tooltip .tooltip-top {
  width: 120px;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
}

.tooltip .tooltip-top::after {
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-color: black transparent transparent transparent;
}

@media (min-width: 2737px) and (max-width: 7680px) {
    .tooltip .tooltiptext {
        width: 300px;
        font-size: 33px;
    }
}
</style>